/**
 * Returns the display color for a calendar event type.
 */
export function eventColor(type: string): string {
  switch (type) {
    case 'appointment':
      return '#3b82f6';
    case 'travel':
      return '#8b5cf6';
    case 'event':
      return '#10b981';
    case 'deadline':
      return '#ef4444';
    default:
      return '#6b7280';
  }
}
